import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { getUserAuthenticated } from '../../../redux/actions/authActions'
import { navigate } from '@reach/router'

const AuthCheck = ({ auth, getUserAuthenticated }) => {
  const { isAuth, user } = auth

  useEffect(() => {
    getUserAuthenticated()

    if (isAuth) {
        user?.role ? navigate('/admin/inicio') : navigate('/aspirantes/inicio');
    } else {
        navigate('/aspirantes/login');
    }
        
  }, [])
  
  return (
    <></>
  )
}

export default connect(state => ({ auth: state.auth }),{getUserAuthenticated})(AuthCheck)